<template>
<Card v-if="store.attachments.length > 0"
    class="w-9 ml-2 shadow-2">
  <template #title>Existujúce prílohy</template>
  <template #content>  
  <div class="pt-1 pb-1 flex flex-wrap gap-1 mr-1">
    <div
        v-for="att in store.attachments"
        :key="att.id"
        class="shadow-2 p-1 flex surface-card w-13rem"
        style="border-radius: 6px"
    >
      <div class="p-1 w-10">

        <div v-if="att.thumbnail" class="thumbnail-container flex align-items-center justify-content-center
              h-8rem border-solid border-1 surface-border border-round-sm">
          <img
              :src="thumbnailUrl(att)"
              alt="Thumbnail"
              class="w-full h-full border-round-sm cursor-pointer"
              @click="openModal(att)"
          />
        </div>
        <div
          class="w-full h-8rem flex align-items-center justify-content-center
                border-solid border-1 surface-border border-round-sm"
          v-else
        >
          <i class="pi pi-ban text-6xl font-light text-500"></i>
        </div>
        <div class="w-10rem text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis">
          {{ att.name + "." + att.fileExt }}
        </div>
        <div class="text-400 text-xs">{{ formattedFileSize(att.size) }}</div>
      </div>
      <div class="p-1 w-2 ">
        <div class="download p-1 align-items-center justify-content-center flex">
          <a :href="store.Api_url + '/download/' + att.id ">
            <PrimevueButton icon="pi pi-download" severity="secondary" aria-label="Download" />
          </a>
        </div>  
        <div class="p-1 align-items-center justify-content-center flex">
          <div>
            <PrimevueButton @click="onRemoveFile(att.id)" class="file-danger" icon="pi pi-times" severity="danger" aria-label="Delete" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Window -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="p-1 align-items-center justify-content-center flex">
           <img :src="modalImage" alt="Full Image" class="modal-image" />
        </div>
        <button class="modal-close-btn" @click="closeModal">X</button>
      </div>
    </div>
  </div>
</template>
</Card>  
</template>

<script lang="ts">
import Security from "./security";
import { store } from "./store";
import Utils from "@/components/utils";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import Card from "primevue/card";

export default {
  name: "AttachmentList",
  components: {
    PrimevueButton,
    Card,
  },
  props: {
    orderId: String,
    //internal: Boolean,
    //attTypeId: Number,
  },
  data() {
    return {
      store,
      //attachments: [],
      showModal: false, // Modal visibility state
      modalImage: "",   // Selected image URL for modal
    };
  },
  computed: {
    Utils() {
      return Utils;
    },
  },
  methods: {
    formattedFileSize(fileSize: number): string {
      return Math.round(fileSize / Math.pow(1024, 1)) + " KB";
    },

    thumbnailUrl(att: any): string {
      return store.Api_url + "/thumbnail/" + att.id;
    },

    openModal(att: any) {
      this.modalImage = this.thumbnailUrl(att);
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.modalImage = "";
    },

    onRemoveFile(attId: string) {
      if (confirm("Naozaj chcete smazat tuto prílohu?")) {
        Security.requireToken();
        fetch(store.Api_url + "/v1/attachment/" + attId, Security.requestOptions("DELETE"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              notie.alert({
                type: "error",
                text: "Nepodarilo se zmazať prílohu",
                position: "bottom",
              });
            } else {
              store.attachments = store.attachments.filter((att) => att.id !== attId);
              notie.alert({
                type: "success",
                text: "Príloha bola úspešne zmazaná",
                position: "bottom",
              });
            }
          })
          .catch((error) => {
            notie.alert({
              type: "error",
              text: "Chyba pri mazaní prílohy: " + error,
              position: "bottom",
            });
          });
      }
    },
  },
  beforeMount() {
    Security.requireToken();
    //store.selectModul = this.$route.path.split("/")[1];

    Utils.getAttachments(this.$props.orderId);
  },
};
</script>

<style>
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  max-width: 70vw;
  max-height: 90vh;
}

.modal-image {
  /*
  width: 100%;
  height: 600px;
  */
  max-width: 30vw;
  max-height: 80vh;
  border-radius: 8px;
}

.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ff5f5f;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 1.2rem;
}

.cursor-pointer {
  cursor: pointer;
}

.p-button.p-button-icon-only {
  width: auto;
}
</style>